import React from 'react';
import { Ellipsis, Icon } from '../../../../common';
import { Handle, Position } from 'reactflow';
import './style/index.less';
const connectionNodeIdSelector = state => state.connectionStartHandle;
export default function ({ config, instance }) {
    const { nodeStyle, nodeClassName, statusIcon, isDndPreview } = instance;
    const { icon, label, highlight } = config;
    const { width, height } = config;
    return (React.createElement("div", { className: `oflow-client--square-node   
    ${highlight ? 'oflow-client--square-node--highlight' : ''}  
    ${nodeClassName ? nodeClassName : ''}`, style: { width, height } },
        !isDndPreview ? (React.createElement(React.Fragment, null,
            React.createElement(Handle, { type: "target", position: Position.Left, style: { top: 10, background: '#ccc' }, id: 'asdasdasd' }),
            React.createElement(Handle, { type: "source", position: Position.Right, id: '42341125125' }),
            React.createElement(Handle, { type: "target", position: Position.Top, style: { top: 10, background: '#ccc' }, id: 'xxxx' }),
            React.createElement(Handle, { type: "source", position: Position.Bottom, id: '90ds8g09s8g' }))) : null,
        React.createElement("div", { className: "oflow-client--square-node--content", style: nodeStyle },
            icon ? (React.createElement("div", { className: "oflow-client--square-node--icon", style: {
                    background: instance === null || instance === void 0 ? void 0 : instance.primaryColor,
                } },
                React.createElement(Icon, { icon: icon, style: { color: '#fff', width: 20, height: 20, fontSize: 20 } }))) : null,
            React.createElement("div", { className: "oflow-client--square-node--title" },
                React.createElement("div", { className: "oflow-client--square-node--text" },
                    React.createElement(Ellipsis, null, label)),
                statusIcon ? (React.createElement(Icon, { icon: statusIcon, style: { color: '#fff', width: 12, height: 12, fontSize: 12 } })) : null))));
}
//# sourceMappingURL=index.js.map